import React, { InputHTMLAttributes, useState } from "react";
import IconVisible from "../../assets/images/ojo-abierto.png";
import IconInvisible from "../../assets/images/ojo.png";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  classNameContainer?: string;
  classNameInput?: string;
  error?: string;
  required?: boolean;
  loading?: boolean;
}

const InputPassword = ({
  classNameContainer,
  classNameInput,
  error,
  required = false,
  loading = false,
  ...props
}: InputProps) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className={`${classNameContainer ? classNameContainer : ""} relative`}>
      <div className="h-10">
        <p className="my-0 py-0 text-base">
          {props.placeholder}{" "}
          {required && (
            <span className="text-center text-3xl text-critical">*</span>
          )}
          {error && (
            <span className="my-0 py-0 text-base text-critical">{error}</span>
          )}
        </p>
      </div>
      <input
        className={`${classNameInput ? classNameInput : ""} rounded-lg bg-gray px-3 py-2 text-textBlack`}
        type={visible ? "text" : "password"}
        {...props}
      />

      <button
        className={`absolute right-2 top-5 z-50 h-full rounded-r-md`}
        onClick={() => setVisible((prev) => !prev)}
      >
        {visible ? (
          <img src={IconVisible} className="w-5" />
        ) : (
          <img src={IconInvisible} className="w-6" />
        )}
      </button>

      {loading && (
        <div
          className="absolute right-0 top-12 z-50 mr-2 h-5 w-5 animate-spin rounded-full border-4 border-b-gray border-l-gray border-r-gray"
          style={{ borderTopColor: "#461E7D" }}
        />
      )}
    </div>
  );
};

export default InputPassword;
